import MuiInputLabel, { InputLabelProps } from "@mui/material/InputLabel";
import { TYPOGRAPHY } from "./styles";
import { FIGMA_COLORS } from "./styles/colors";

const denseStyle = {
  margin: 0,
};
const regularStyle = {
  marginBottom: "7px",
};

function InputLabel({
  sx,
  error,
  dense = false,
  ...props
}: {
  sx?;
  dense?: boolean;
  error?: boolean;
} & Partial<InputLabelProps>) {
  return (
    <MuiInputLabel
      shrink={false}
      sx={{
        "&.Mui-focused": {
          color: error ? FIGMA_COLORS.errorLight : FIGMA_COLORS.primaryLight,
        },
        scale: "none",
        transform: "none",
        position: "relative",
        ...TYPOGRAPHY.labelSmall,
        color: error ? FIGMA_COLORS.errorLight : FIGMA_COLORS.onSurfaceSubtleLight,
        lineHeight: "20px",
        ...(dense ? denseStyle : regularStyle),
        ...sx,
      }}
      {...props}
    />
  );
}

export default InputLabel;
